import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  Modal,
  Drawer,
  Divider,
  Checkbox,
  TableSortLabel,
} from "@mui/material";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { FiEdit } from "react-icons/fi";
import { BsFillXCircleFill } from "react-icons/bs";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import Swal from "sweetalert2";
import ClearIcon from "@mui/icons-material/Clear";
import { dataProductList } from "../Service";
import LinearProgress from "@mui/material/LinearProgress";

import moment from "moment";
import LoadingButton from "@mui/lab/LoadingButton";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import GradingIcon from "@mui/icons-material/Grading";
import CheckIcon from "@mui/icons-material/Check";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useLocation } from "react-router-dom";
import BtnUpdFileIcon from "../../img/UploadFileWhite.png";
import { addLog } from "../../utils/addLog";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { dataAccessPermission } from "../../utils/dataAccessPermission";
// import { getToken } from "../../utils/getToken";
import { signOut } from "../../utils/signOut";

const styleGrayBtn = {
  backgroundColor: "#5C5C5C",
  color: "#FFFFFF",
  borderRadius: "10px",
  height: "45px",
  textTransform: "none",
  width: "100px",
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const styleModaldelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 200,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 3,
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        ml: 2.5,
      }}
    >
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function AddProduct({ onAddProduct }) {
  const [t, i18n] = useTranslation("global");

  const styles = {
    BtnIcon: {
      width: 32,
      height: 32,
    },
  };
  // const [userRole, setUserRole] = React.useState(
  //   JSON.parse(sessionStorage.getItem("authUserRole"))
  // );

  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("GroupID");
  const [dataProduct, setDataProduct] = useState([]);
  const [order, setOrder] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState({ total: 0 });
  const [searchInput, setSearchInput] = useState("");

  const [errorMsg, setErrorMsg] = useState("");
  const [sumErrorMsg, setSumErrorMsg] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingSh, setLoadingSh] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProdSplitLine, setSelectedProdSplitLine] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedProduct(null);
    setSelectedProdSplitLine(null);
  };

  const handleSelect = (id) => {
    const newSelected = selected.includes(id)
      ? selected.filter((item) => item !== id)
      : [...selected, id];
    setSelected(newSelected);
  };
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setErrorMsg("");
  };
  const handleClearSearchProduct = () => {
    // setDataProduct([]);
    // setData({ total: 0 });
    setSearchInput("");
    setSelected([]); // Clear selected row
  };

  const [openModalInsert, setOpenModalInsert] = useState(false);
  const [loadingBtnGrounding, setLoadingBtnInsert] = useState(false);
  const handleOpenModalGrounding = () => {
    setOpenModalInsert(true);
  };
  const handleCloseModalInsert = () => setOpenModalInsert(false);

  const handleClickModalInsert = () => {
    // addLog("BOQ", "Add product", null);
    setLoadingBtnInsert(true);
    insertMultiProducts();
  };

  const insertMultiProducts = () => {
    // // Filter data based on isChecked then Remove the isChecked field from each item
    // const checkedItems = dataProduct
    //   .filter((item) => item.isChecked)
    //   .map(({ isChecked, ...rest }) => rest);

    // checkedItems.map((item) => {
    //   onAddProduct(item);
    // });

    // Filter data based on isChecked then Remove the isChecked field from each item
    const checkedItems = dataProduct.filter((item) =>
      selected.includes(item.IDItem)
    );
    checkedItems.map((item) => {
      onAddProduct(item);
    });
    // onAddProduct("Hello");

    // Close confirm popup
    setLoadingBtnInsert(false);
    handleCloseModalInsert();

    // Close Add product window
    setOpenModalInsert(false);

    // Clear selected row
    setSelected([]);
  };

  const sortedData = [...dataProduct].sort((a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    } else {
      return a[orderBy] > b[orderBy] ? -1 : 1;
    }
  });

  const headCells = [
    {
      id: "code",
      numeric: false,
      disablePadding: true,
      sortKey: "IDItem",
      label: t("grounding.table.header.code"),
    },
    {
      id: "product",
      numeric: false,
      disablePadding: true,
      sortKey: "itemname",
      label: t("grounding.table.header.product"),
    },
    {
      id: "uom",
      numeric: false,
      disablePadding: false,
      // sortKey: null,
      sortKey: "UoMItem",
      label: t("grounding.table.header.uom"),
    },
    {
      id: "model",
      numeric: false,
      disablePadding: false,
      sortKey: "model",
      label: t("grounding.table.header.model"),
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      sortKey: "ItemDescription",
      label: t("grounding.table.header.description"),
    },
    {
      id: "MatLaborCost",
      numeric: true,
      disablePadding: false,
      sortKey: "MaterialLaborCost",
      label: t("grounding.table.header.labor_price"),
    },
    {
      id: "uprice",
      numeric: true,
      disablePadding: false,
      sortKey: "material_Price",
      label: t("grounding.table.header.price"),
    },
    {
      id: "PriceHomepro",
      numeric: true,
      disablePadding: false,
      sortKey: "matPriceHome",
      label: t("grounding.table.header.priceHome"),
    },
    {
      id: "PriceThaiWat",
      numeric: true,
      disablePadding: false,
      sortKey: "matPriceThai",
      label: t("grounding.table.header.priceThai"),
    },
    {
      id: "PriceBoon",
      numeric: true,
      disablePadding: false,
      sortKey: "matPriceBoon",
      label: t("grounding.table.header.priceBoon"),
    },
    {
      id: "Other",
      numeric: true,
      disablePadding: false,
      sortKey: "matPriceOth",
      label: t("grounding.table.header.priceOth"),
    },
    {
      id: "Reference",
      numeric: false,
      disablePadding: false,
      sortKey: null,
      label: t("grounding.table.header.ref"),
    },
    {
      id: "SearchedOn",
      numeric: false,
      disablePadding: false,
      sortKey: "last_updated",
      label: t("grounding.table.header.last"),
    },
  ];

  // Snack Bar
  const vertical = "top";
  const horizontal = "right";
  const [openSnack, setOpenSnack] = useState(false);

  const handleClickSnack = () => {
    setOpenSnack(true);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack(false);
  };

  React.useEffect(() => {
    getData(0, rowsPerPage);
  }, []);

  const getData = async (nowPage, nowRowsPerPage) => {
    setSelected([]); // Clear selected row
    setLoading(true);

    const role = dataAccessPermission("OWNER");

    var nowPages = nowPage + 1;

    let qString = `?page=${nowPages}&perpage=${nowRowsPerPage}`;
    qString += `&UserRole=${role}`;
    if (searchInput) qString = qString + "&KeyWord=" + searchInput;

    dataProductList(qString).then((res) => {
      if (res && res.status === 200) {
        // For paginate
        setDataProduct(res.data.data);
        setData(res.data);
      } else if (res.status === 401) {
        signOut();
      } else {
        Swal.fire({
          icon: "error",
          title: res.data.message,
          text: res.data.error,
        });
      }
      setLoading(false);
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getData(0, event.target.value);
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Enter" && searchInput.length > 0) {
      // Handle the Enter key press
      setPage(0);
      getData(0, rowsPerPage);
    }
  };
  const handleChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleClickSearch = () => {
    setPage(0);
    getData(0, rowsPerPage);
  };

  let NumberForm = new Intl.NumberFormat("th-TH", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  function CodeForm(id) {
    return String(id).padStart(5, "0"); // Pads the number to be 5 characters long
  }

  // Copy to clipboard
  // const [copied, setCopied] = useState(false);
  const handleCopyClick = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy).then(() => {
      setOpenSnack(true);
    });
  };

  return (
    <Box>
      <Snackbar
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        message={t("common.message.copy")}
      />

      {/*  ////////////////////////// Search Box ////////////////////////// */}
      <Box
        sx={{
          display: "flex",
          paddingBottom: "20px",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              minWidth: { lg: "500px", md: "500px" },
              display: "flex",
              mr: 2,
            }}
          >
            <TextField
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderColor: "white",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
              }}
              // placeholder="Search here"
              placeholder={t("genboq.modal.addproduct.txtbox.search")}
              size="middle"
              variant="outlined"
              InputProps={{
                style: {
                  borderRadius: "10px",
                  backgroundColor: "#F0F0F0",
                  paddingLeft: "15px",
                  fontSize: "medium",
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <IconButton
                    sx={{
                      visibility: searchInput ? "visible" : "hidden",
                    }}
                    onClick={handleClearSearchProduct}
                  >
                    <ClearIcon />
                  </IconButton>
                ),
              }}
              fullWidth
              value={searchInput}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
          </Box>

          <Box>
            <LoadingButton
              onClick={handleClickSearch}
              variant="contained"
              size="small"
              sx={styleGrayBtn}
            >
              {t("common.button.search")}
            </LoadingButton>
          </Box>
        </Box>
        <Box>
          {selected.length > 0 ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Box sx={{ mr: 2 }}>
                  <Typography>
                    {t("genboq.popup.addpro.sel")}
                    {selected.length}
                    {t("genboq.popup.addpro.unit")}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", mr: 2 }}>
                  <Button
                    onClick={handleOpenModalGrounding}
                    variant="contained"
                    size="medium"
                    style={{
                      textTransform: "none",
                      borderRadius: "10px",
                      height: "45px",
                      backgroundColor: "#7399D1",
                    }}
                  >
                    {t("genboq.button.insert")}
                  </Button>
                </Box>
              </Box>
            </>
          ) : (
            ""
          )}
        </Box>
      </Box>

      {/*  ////////////////////////// Data Table ////////////////////////// */}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              <TableCell
                padding="checkbox"
                sx={{
                  backgroundColor: "#c4e6ff",
                }}
              >
                <Checkbox
                  checked={
                    selected.length === dataProduct.length &&
                    dataProduct.length !== 0
                  }
                  onChange={() =>
                    setSelected(
                      selected.length === dataProduct.length
                        ? []
                        : dataProduct.map((item) => item.IDItem)
                    )
                  }
                />
              </TableCell>

              {headCells.map((headCell, index) => (
                <TableCell
                  key={index}
                  align={headCell.numeric ? "right" : "left"}
                  padding={headCell.disablePadding ? "none" : "normal"}
                  sx={{
                    backgroundColor: "#c4e6ff",
                    padding: "10px",
                    fontWeight: "bold",
                    color: "#1D589D",
                  }}
                  sortDirection={orderBy === headCell.sortKey ? order : false}
                >
                  {headCell.sortKey !== null ? (
                    <TableSortLabel
                      active={orderBy === headCell.sortKey}
                      direction={orderBy === headCell.sortKey ? order : "asc"}
                      onClick={() => handleRequestSort(headCell.sortKey)}
                    >
                      {headCell.label}
                    </TableSortLabel>
                  ) : (
                    headCell.label
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={13}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress color="inherit" />
                  </Box>
                </TableCell>
              </TableRow>
            ) : sortedData.length > 0 ? (
              sortedData.map((row, index) => (
                <React.Fragment key={index}>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selected.includes(row.IDItem)}
                        onChange={() => handleSelect(row.IDItem)}
                      />
                    </TableCell>
                    <TableCell style={{ width: 50 }} align="left">
                      <Typography>{CodeForm(row.IDItem)}</Typography>
                    </TableCell>
                    <TableCell style={{ minWidth: "250px" }} align="left">
                      <Button
                        variant="text"
                        style={{
                          textTransform: "none",
                          fontSize: "16px",
                          textAlign: "left",
                          display: "flex",
                          justifyContent: "flex-start",
                          color: "black",
                        }}
                        size="small"
                      >
                        <Typography
                          sx={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            WebkitLineClamp: 2, // Limits to 2 lines
                            textOverflow: "ellipsis",
                          }}
                        >
                          {row.itemname}
                        </Typography>
                      </Button>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="left">
                      <Typography>{row.UoMItem}</Typography>
                    </TableCell>
                    <TableCell
                      style={{
                        minWidth: "50px",
                        maxWidth: "120px",
                      }}
                      align="left"
                    >
                      <Typography
                        sx={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          WebkitLineClamp: 2, // Limits to 2 lines
                          textOverflow: "ellipsis",
                        }}
                      >
                        {row.model}
                      </Typography>
                    </TableCell>

                    <TableCell style={{ minWidth: "250px" }} align="left">
                      <Typography
                        sx={{
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          WebkitLineClamp: 2, // Limits to 2 lines
                          textOverflow: "ellipsis",
                        }}
                      >
                        {row.ItemDescription}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="right">
                      <Typography>
                        {NumberForm.format(row.MaterialLaborCost)}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="right">
                      <Typography>
                        {NumberForm.format(row.material_Price)}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="right">
                      <Typography>
                        {NumberForm.format(row.matPriceHome)}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="right">
                      <Typography>
                        {NumberForm.format(row.matPriceThai)}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="right">
                      <Typography>
                        {NumberForm.format(row.matPriceBoon)}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="right">
                      <Typography>
                        {NumberForm.format(row.matPriceOth)}
                      </Typography>
                    </TableCell>

                    <TableCell style={{ minWidth: 80 }} align="left">
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        {row.urlHome ? (
                          <Button
                            variant="text"
                            style={{
                              textTransform: "none",
                              textAlign: "left",
                              display: "flex",
                              justifyContent: "flex-start",
                              padding: 0,
                            }}
                            size="small"
                          >
                            <Typography
                              style={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                              sx={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                WebkitLineClamp: 1, // Limits to 1 lines
                                textOverflow: "ellipsis",
                                fontSize: "12px",
                              }}
                            >
                              <a
                                href={row.urlHome}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                HomePro
                              </a>
                            </Typography>
                          </Button>
                        ) : (
                          ""
                        )}

                        {row.urlThai ? (
                          <Button
                            variant="text"
                            style={{
                              textTransform: "none",
                              textAlign: "left",
                              display: "flex",
                              justifyContent: "flex-start",
                              padding: 0,
                            }}
                            size="small"
                          >
                            <Typography
                              style={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                              sx={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                WebkitLineClamp: 1, // Limits to 1 lines
                                textOverflow: "ellipsis",
                                fontSize: "12px",
                              }}
                            >
                              <a
                                href={row.urlThai}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                Thai watsadu
                              </a>
                            </Typography>
                          </Button>
                        ) : (
                          ""
                        )}

                        {row.urlBoon ? (
                          <Button
                            variant="text"
                            style={{
                              textTransform: "none",
                              textAlign: "left",
                              display: "flex",
                              justifyContent: "flex-start",
                              padding: 0,
                            }}
                            size="small"
                          >
                            <Typography
                              style={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                              sx={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                WebkitLineClamp: 1, // Limits to 1 lines
                                textOverflow: "ellipsis",
                                fontSize: "12px",
                              }}
                            >
                              <a
                                href={row.urlBoon}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                              >
                                Boonthavorn
                              </a>
                            </Typography>
                          </Button>
                        ) : (
                          ""
                        )}
                        {row.urlOth ? (
                          row.urlOth.startsWith("https://") ? (
                            <Button
                              variant="text"
                              style={{
                                textTransform: "none",
                                textAlign: "left",
                                display: "flex",
                                justifyContent: "flex-start",
                                padding: 0,
                              }}
                              size="small"
                            >
                              <Typography
                                style={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }}
                                sx={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  WebkitLineClamp: 1, // Limits to 1 lines
                                  textOverflow: "ellipsis",
                                  fontSize: "12px",
                                }}
                              >
                                <a
                                  href={row.urlOth}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                >
                                  Other
                                </a>
                              </Typography>
                            </Button>
                          ) : (
                            <div>
                              <Button
                                variant="text"
                                style={{
                                  textTransform: "none",
                                  textAlign: "left",
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  padding: 0,
                                }}
                                size="small"
                                onClick={() => {
                                  handleCopyClick(row.urlOth);
                                }}
                              >
                                <Typography
                                  style={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                  sx={{
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    WebkitLineClamp: 1, // Limits to 1 lines
                                    textOverflow: "ellipsis",
                                    fontSize: "12px",
                                  }}
                                >
                                  Other
                                </Typography>
                              </Button>
                            </div>
                          )
                        ) : (
                          ""
                        )}

                        {row.urlOth2 ? (
                          row.urlOth2.startsWith("https://") ? (
                            <Button
                              variant="text"
                              style={{
                                textTransform: "none",
                                textAlign: "left",
                                display: "flex",
                                justifyContent: "flex-start",
                                padding: 0,
                              }}
                              size="small"
                            >
                              <Typography
                                style={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }}
                                sx={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  WebkitLineClamp: 1, // Limits to 1 lines
                                  textOverflow: "ellipsis",
                                  fontSize: "12px",
                                }}
                              >
                                <a
                                  href={row.urlOth2}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                >
                                  Other2
                                </a>
                              </Typography>
                            </Button>
                          ) : (
                            <div>
                              <Button
                                variant="text"
                                style={{
                                  textTransform: "none",
                                  textAlign: "left",
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  padding: 0,
                                }}
                                size="small"
                                onClick={() => {
                                  handleCopyClick(row.urlOth2);
                                }}
                              >
                                <Typography
                                  style={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                  sx={{
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    WebkitLineClamp: 1, // Limits to 1 lines
                                    textOverflow: "ellipsis",
                                    fontSize: "12px",
                                  }}
                                >
                                  Other2
                                </Typography>
                              </Button>
                            </div>
                          )
                        ) : (
                          ""
                        )}
                      </Box>
                    </TableCell>

                    <TableCell style={{ minWidth: "100px" }} align="left">
                      <Typography variant="body2">
                        {row.last_updated
                          ? moment(row.last_updated).format(
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          : ""}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={13}>
                  <Box
                    style={{ display: "flex", justifyContent: "center" }}
                  ></Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                colSpan={13}
                count={data.total}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      {/* /////////// Modal confirm grounding search /////////// */}
      <Modal open={openModalInsert}>
        <Box sx={styleModaldelete}>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography marginTop={1} variant="h5" component="h2">
              {t("genboq.popup.addpro.header")}
            </Typography>
            <IconButton size="large" onClick={handleCloseModalInsert}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            sx={{ mt: 3, color: "#616161" }}
            fontSize={14}
            fontWeight={300}
          >
            {t("genboq.popup.addpro.txt1")}
          </Typography>
          <Box
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "5rem",
            }}
          >
            <LoadingButton
              onClick={handleClickModalInsert}
              loading={loadingBtnGrounding}
              loadingPosition="start"
              startIcon={<SearchIcon />}
              variant="contained"
              size="small"
            >
              {t("genboq.button.insert")}
            </LoadingButton>
            <Button
              style={{ marginLeft: 12 }}
              variant="outlined"
              size="medium"
              onClick={handleCloseModalInsert}
            >
              <Typography fontSize={14}>{t("common.button.cancel")}</Typography>
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Drawer Product detail */}
      <Drawer anchor="right" open={drawerOpen} onClose={handleCloseDrawer}>
        <Box sx={{ width: 350, padding: 2 }} role="presentation">
          {selectedProduct && (
            <>
              <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                <Typography variant="h6">Product /&nbsp;</Typography>
                <Typography variant="h6" color="primary">
                  {selectedProduct.itemname}
                </Typography>
              </Box>
              <Box
                sx={{
                  marginTop: 2,
                  display: "flex",
                  flexDirection: "column",
                  width: "60%",
                }}
              >
                <Box sx={{ marginBottom: 2 }}>
                  <Typography variant="subtitle2">Product code</Typography>
                  <Typography>{selectedProduct.IDItem}</Typography>
                  <Divider />
                </Box>
                <Box sx={{ marginBottom: 2 }}>
                  <Typography variant="subtitle2">Product name</Typography>
                  <Typography>{selectedProduct.itemname}</Typography>
                  <Divider />
                </Box>
                <Box sx={{ marginBottom: 2 }}>
                  <Typography variant="subtitle2">Price</Typography>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography>{selectedProduct.material_Price}</Typography>
                    <Typography>฿</Typography>
                  </Box>
                  <Divider />
                </Box>
                <Box sx={{ marginBottom: 2 }}>
                  <Typography variant="subtitle2">Company</Typography>
                  <Typography>
                    {selectedProduct.company ? selectedProduct.company : "N/A"}
                  </Typography>
                  <Divider />
                </Box>
              </Box>
              <Box>
                <Box sx={{ marginBottom: 2 }}>
                  <Typography variant="subtitle2">Reference</Typography>
                  <Box sx={{ width: "100%" }}>
                    <Typography
                      style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                    >
                      {selectedProduct.URI ? selectedProduct.URI : "N/A"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ marginBottom: 2, marginTop: 2 }}>
                  <Typography variant="subtitle2">Description</Typography>
                  <Box>
                    {selectedProdSplitLine.map((detail, index) => (
                      <Typography
                        key={index}
                        variant="body1"
                        component="div"
                        sx={{ display: "flex", alignItems: "center" }}
                      >
                        <span style={{ marginRight: "8px", fontSize: "20px" }}>
                          •
                        </span>
                        {detail}
                      </Typography>
                    ))}
                  </Box>
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Drawer>
    </Box>
  );
}
